import Hl7Messages, {ColumnTypes} from "./hl7_messages_comp";
import * as React from "react";
import Formatter from "../../../util/formatter";
import {useSelector} from "react-redux";
import {agylePref} from "../../../store/reducers/preferences";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import _ from "lodash";
import {useEffect} from "react";
import ColumnsManager, {getColumns} from "./columns_manager";

function Hl7outMessages(props){

    const agylePreference = useSelector(agylePref);
    const [columns, setColumns] = React.useState([])
    const [openConfig, setOpenConfig] = React.useState(false);
    const isEyonix = process.env.BUILD_MODULE === "main";
    useEffect(()=>{
        setColumns(getColumns((isEyonix ? columnsInitEyonix : columnsInit), agylePreference?.outMessageColumnOrder));
    },[agylePreference]);
    const columnsInitEyonix = [
        {
            name: 'createDate',
            order: 1,
            value: '_createdDate',
            type: ColumnTypes.TEXT,
            description: 'Created Date',
            withMessage: true,
            minWidth: 10,
            maxWidth: 175,
            sort: true,
            defaultSort: true,
            format: (value) => {
                return Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss", "");
            }},
        {
            name: 'messageType',
            order: 1,
            value: 'messageType',
            type: ColumnTypes.TEXT,
            description: 'Type',
            sort: true,
            minWidth: 10 },
        {
            name: 'hospitalNumber',
            order: 1,
            value: 'hospitalNumber',
            type: ColumnTypes.TEXT,
            description: 'Hospital number',
            sort: true,
            minWidth: 10
        },
        {
            name: 'messageId',
            order: 1,
            value: 'messageId',
            sort: true,
            type: ColumnTypes.TEXT,
            description: 'Message ID',
            minWidth: 10
        },
    ];
    const columnsInit = [
        {
            name: 'action',
            order: 1,
            value: 'action',
            type: ColumnTypes.CHEACKBOX,
            description: 'Info',
            minWidth: 30
        },
        {
            name: 'createDate',
            order: 1,
            value: '_createDate',
            type: ColumnTypes.TEXT,
            description: 'Created',
            withMessage: true,
            minWidth: 10,
            maxWidth: 175,
            sort: true,
            defaultSort: true,
            format: (value) => {
                return Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss", "");
            }},
        {
            name: 'messageType',
            order: 1,
            value: 'messageType',
            type: ColumnTypes.TEXT,
            description: 'Type',
            sort: true,
            minWidth: 10 },
        {
            name: 'hospitalNumber',
            order: 1,
            value: 'patient._id',
            type: ColumnTypes.TEXT,
            description: 'Hospital number',
            sort: true,
            minWidth: 10 },
        {
            name: 'patientName',
            order: 1,
            value: 'patient',
            type: ColumnTypes.TEXT,
            description: 'Patient',
            minWidth: 10,
            format: (patient) => {
                return patient? patient.firstName + " "+ patient.familyName: "NO PATIENT";
            }},
        {
            name: 'status',
            order: 1,
            value: 'status',
            sort: true,
            type: ColumnTypes.TEXT,
            description: 'Status',
            minWidth: 10 },
        {
            name: 'lastSendTime',
            order: 1,
            value: 'send',
            type: ColumnTypes.TEXT,
            description: 'Last Send Time ',
            minWidth: 10,
            format: (send) => {
                if(send && send.length > 0)
                    return Formatter.utcAndLocalFormatData( send[send.length - 1]._createDate,"YYYY-MM-DD HH:mm:ss", "");
            }},
        {
            name: 'lastStatus',
            order: 1,
            value: 'send',
            type: ColumnTypes.TEXT,
            description: 'Last Status',
            minWidth: 10,
            maxWidth: 175,
            format: (send) => {
                if(send && send.length > 0)
                    return send[send.length - 1].status;
            }},
        {
            name: 'hl7Type',
            order: 1,
            value: 'send',
            type: ColumnTypes.TEXT,
            description: 'Hl7 Type',
            minWidth: 10 ,
            format: (send) => {
                if(send && send.length > 0)
                return send[send.length - 1].hl7Type;
            }},
    ];


    const getMessage = (row) => {
        if(isEyonix) {
            return row.message;
        }
        return row.send && row.send.length > 0 ? row.send[row.send.length - 1].hl7message : " - ";
    }


    const sortColumn = () => {
        const filteredColumns = _.filter(columns, col => {
            return !_.isNil(col.order);
        });

        return _.sortBy(filteredColumns, obj => {
            return obj.order;
        });
    };

    return (<div>
        {/*<IconButton*/}
        {/*    size={"small"}*/}
        {/*    disableRipple={true}*/}
        {/*    onClick={() => setOpenConfig(true)}>*/}
        {/*    <SettingsIcon/>*/}
        {/*</IconButton>*/}

        <ColumnsManager prefPath={"outMessageColumnOrder"}
                        columns = {columns}
                        title={"Outgoing Messages Columns Settings"}
                        columnsInit = {columnsInit}
                        openConfig={openConfig}
                        closeModal={() => setOpenConfig(false)}/>

        <Hl7Messages outcoming openColumnManager={() => setOpenConfig(true)} webSocketChanel = {"db_hl7_outcoming_messages"} columns={sortColumn()} messagePath={getMessage} {...props}/>

    </div>)
}
export default Hl7outMessages;